import { getBrandIcon } from '@/integrations/integration-icons';

import { providerName } from './providerIdentity';

import type { ComponentType } from 'react';

type LinkedApp = {
  icon: ComponentType<{ className?: string }>;
  name: string;
};

// The toolkit a link's host belongs to, where Littlebird knows the app's mark
const APP_BY_HOST: readonly [RegExp, string][] = [
  [/(^|\.)github\.com$/, 'github'],
  [/(^|\.)slack\.com$/, 'slack'],
  [/^mail\.google\.com$/, 'gmail'],
  [/^calendar\.google\.com$/, 'googlecalendar'],
  [/^drive\.google\.com$/, 'googledrive'],
  [/(^|\.)linear\.app$/, 'linear'],
  [/(^|\.)notion\.(so|site)$/, 'notion'],
  [/(^|\.)todoist\.com$/, 'todoist'],
  [/^outlook\.(office|office365|live)\.com$/, 'outlook'],
  [/(^|\.)asana\.com$/, 'asana'],
];

// Google's documents share one host, so the path says which app
const GOOGLE_DOCS_BY_PATH: readonly [RegExp, string][] = [
  [/^\/spreadsheets\//, 'googlesheets'],
  [/^\/forms\//, 'googleforms'],
  [/^\//, 'googledocs'],
];

const toolkitOf = (url: URL): string | undefined => {
  if (url.hostname === 'docs.google.com')
    return GOOGLE_DOCS_BY_PATH.find(([path]) => path.test(url.pathname))?.[1];
  return APP_BY_HOST.find(([host]) => host.test(url.hostname))?.[1];
};

// The app a link opens, with its mark and name, so a card can show "GitHub" where it showed "github.com"
export const appOfUrl = (href: string): LinkedApp | null => {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  const toolkit = toolkitOf(url);
  const icon = toolkit ? getBrandIcon(toolkit) : undefined;
  return toolkit && icon ? { icon, name: providerName(toolkit) } : null;
};
